import { create } from "zustand";
import { persist } from "zustand/middleware";

interface TeamState {
  // 当前团队信息
  currentTeamId: string;

  // 操作
  setCurrentTeamId: (teamId: string) => void;
}

export const useTeamStore = create<TeamState>()(
  persist(
    (set) => ({
      currentTeamId: "",
      setCurrentTeamId: (teamId) => set({ currentTeamId: teamId }),
    }),
    {
      name: "team-store",
      partialize: (state) => ({
        currentTeamId: state.currentTeamId,
      }),
    },
  ),
);
